import { Table } from '@zillow/constellation';
import { LoadingText } from '@zg-rentals/loading-components';
import { StyledRow } from '../StyledComponents';

export const TasksTableSkeleton = () => {
  return (
    <>
      <Table.Header>
        <Table.Row>
          {Array.from({ length: 6 }).map((_, idx) => (
            <Table.HeaderCell key={idx}>
              <LoadingText isLoading={true} loadingWidth="60%" textStyle="body-bold">
                Loading
              </LoadingText>
            </Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {Array.from({ length: 5 }).map((_, idx) => {
          return (
            <StyledRow key={`loading-row-${idx}`}>
              {Array.from({ length: 6 }).map((_, idx) => (
                <Table.Cell key={idx}>
                  <LoadingText isLoading={true} loadingWidth="100%" textStyle="body">
                    Loading
                  </LoadingText>
                </Table.Cell>
              ))}
            </StyledRow>
          );
        })}
      </Table.Body>
    </>
  );
};
